import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Swhc3DRoutingModule } from "./swhc3d-routing.module";
import { LynxFrontSwhcModule } from "lynx-front-swhc";

import { Swhc3dComponent } from "src/app/components/swhc3d/swhc3d.component";

interface Definintion {
  kind: string;
  operation?: string;
}

@NgModule({
  declarations: [Swhc3dComponent],
  imports: [CommonModule, Swhc3DRoutingModule, LynxFrontSwhcModule],
  providers: [],
  exports: [Swhc3DRoutingModule, Swhc3dComponent, LynxFrontSwhcModule],
})
export class Swhc3dModule {}
